var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotion3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8476_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "url(#paint0_radial_8476_3695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1563 37.6406C27.7537 37.6406 29.8594 34.6885 29.8594 31.0469C29.8594 27.4052 27.7537 24.4531 25.1563 24.4531C22.5588 24.4531 20.4531 27.4052 20.4531 31.0469C20.4531 34.6885 22.5588 37.6406 25.1563 37.6406Z",
    fill: "url(#paint1_radial_8476_3695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8438 37.6406C57.4412 37.6406 59.5469 34.6885 59.5469 31.0469C59.5469 27.4052 57.4412 24.4531 54.8438 24.4531C52.2463 24.4531 50.1406 27.4052 50.1406 31.0469C50.1406 34.6885 52.2463 37.6406 54.8438 37.6406Z",
    fill: "url(#paint2_radial_8476_3695)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1718 61.7813C37.4062 61.7813 34.625 61.3282 31.8437 60.4063C24.4843 57.9844 19.8281 53.2344 19.6406 53.0313C19.1562 52.5313 19.1718 51.75 19.6718 51.2657C20.1718 50.7813 20.9531 50.7969 21.4375 51.2969C21.4843 51.3438 25.9218 55.8594 32.7187 58.0625C41.7187 60.9844 50.4375 58.6875 58.625 51.2344C59.1406 50.7657 59.9218 50.8125 60.3906 51.3125C60.8593 51.8282 60.8125 52.6094 60.3125 53.0782C55.4218 57.5313 50.2343 60.3125 44.8906 61.3282C43.3281 61.625 41.75 61.7813 40.1718 61.7813Z",
    fill: "url(#paint3_linear_8476_3695)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8476_3695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 40) scale(42.6073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#FFE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFBF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#FF9C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#FFB53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8476_3695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1595 31.0519) scale(5.0975 7.22316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#7A3F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#7E421C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#884D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9B5E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#B4762D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68632"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8476_3695",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.8405 31.0519) scale(5.0975 7.22316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#7A3F1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#7E421C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#884D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#9B5E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#B4762D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C68632"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8476_3695",
    x1: 40.0001,
    y1: 50.4486,
    x2: 40.0001,
    y2: 61.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8476_3695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion3);
export default __webpack_public_path__ + "static/media/emotion3.363ec1576e90ea133cb71eca7dff608b.svg";
export { ForwardRef as ReactComponent };